import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import CompassOverlay from '../compass-overlay'
import { collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import huntImage from '../../../../../../asset/Wind-Icon_Large_FFFFFF_SVG.svg';
import standIconWhite from '../../../../../../asset/stand-icon.png'

class SetIdealWinds extends React.Component {
  constructor(props) {
    super(props)
    this.compassOverlay = null
    this.setWinds = this.setWinds.bind(this)
    this.updateWinds = this.updateWinds.bind(this)
  }

  updateWinds(selectedWind) {
    this.valueOfchild(selectedWind)
  }

  componentDidMount() {
    const { markerTypeId } = this.props.markerData;
    const iconUrl = this.props.markerData.markerType.iconUrl
    const markerColor = this.props.markerData.color
    this.compassOverlay = new CompassOverlay({ iconUrl: iconUrl ? iconUrl : 'https://s3-us-west-2.amazonaws.com/basemap-core-staging/marker/small35/Green.png', markerColor: markerColor, markerData: this.props.markerData, windsData: this.props.winds })
    this.compassOverlay.setMap(this.props.mapReference)
    this.compassOverlay.updateWinds(this.props.winds)
    this.compassOverlay.updateWindsCallback = this.updateWinds // Pass the callback
  }

  componentWillUnmount() {
    this.compassOverlay.setMap(null)
  }

  componentDidUpdate(prevProp, prevState) {
    if (prevProp.winds != this.props.winds) {
      // this.compassOverlay.updateWindsCallback = this.updateWinds // Pass the callback
    }
  }

  setWinds(e) {
    if (!e.target.form) {
      //onsubmit form is target
      e.preventDefault()
    }
    const form = e.target.form ? e.target.form : e.target,
      formData = new FormData(form),
      entries = formData.entries(),
      winds = []

    for (let entry of entries) {
      winds.push(entry[0])
    }

    this.props.setWinds(winds)
    if (!e.target.form) {
      this.props.saveMarker()
    }
  }

  // valueOfchild(value) {
  //   if (!value) {
  //     e.preventDefault(); // Prevent form submission
  //   }
  //   const entries = value, // Assuming `value` is iterable
  //     winds = [...this.props.winds]; // Copy existing winds
  //   // Check if the value exists in winds, if it does remove it, otherwise add it
  //   if (winds.includes(entries)) {
  //     const index = winds.indexOf(entries);
  //     if (index > -1) {
  //       winds.splice(index, 1); // Remove the value from winds
  //     }
  //   } else {
  //     winds.push(entries); // Add the value to winds
  //   }
  //   let removedDuplicates = new Set(winds); // Use Set to ensure uniqueness
  //   this.props.setWinds([...removedDuplicates]); // Set the updated winds
  //   if (!value) {
  //     this.props.saveMarker(); // Call saveMarker if value is falsy
  //   }
  // }

  valueOfchild(value) {
    let windValue = (value) => {
      switch (value) {
        case 'n':
          return value = 's'
          break
        case 's':
          return value = 'n'
          break
        case 'e':
          return value = 'w'
          break
        case 'w':
          return value = 'e'
          break
        case 'ne':
          return value = 'sw'
          break
        case 'sw':
          return value = 'ne'
          break
        case 'se':
          return value = 'nw'
          break
        case 'nw':
          return value = 'se'
          break
      }
    }
    if (!windValue(value)) {
      e.preventDefault();
      this.props.saveMarker();
      return;
    }
    const winds = new Set(this.props.winds);
    if (winds.has(windValue(value))) {
      winds.delete(windValue(value));
    } else {
      winds.add(windValue(value));
    }
    this.props.setWinds([...winds]);
  }

  getChecked(dir) {
    const { winds } = this.props
    return winds.indexOf(dir) !== -1
  }

  makeInputs() {
    const dirs = ['n', 's', 'ne', 'sw', 'e', 'w', 'se', 'nw'],
      { setWinds } = this
    return dirs.map(dir => {
      return (
        <label className='ideal-wind-option' key={`wind-option-${dir}`}>
          <input type='checkbox'
            style={{ scale: '1.5', marginRight: '10px' }}
            checked={this.getChecked(dir)}
            name={dir}
            onChange={setWinds} />{dir.toUpperCase()}
        </label>
      )
    })
  }

  makeTextInput(properties) {
    const { name, width, access, marginLeft } = properties
    return (
      <div style={{ width, height: 68, marginTop: 10, marginLeft }} key={`markerInput-${properties.name}`}>
        <label htmlFor={name}
          className='label-style'
          style={{
            fontSize: '12px',
            textTransform: 'capitalize'
          }}>{`${name}:`}</label>
        <input type='text'
          name={name}
          id={name}
          style={{
            background: ' #333333 0% 0% no-repeat padding-box',
            opacity: 1,
            marginTop: '5px',
            width: access ? width : '86%',
            height: 40,
            border: 'none',
            borderRadius: 5,
            padding: '0 10px',
          }}
          placeholder={name}
          value={properties.displayVal} />
      </div>
    )
  }

  render() {
    if (this.compassOverlay !== null) {
      this.compassOverlay.updateWinds(this.props.winds)
    }
    const { setWinds } = this,
      { markerData, toggleEditing, leftToolbarState, collapseLeftToolbar, fromEdit } = this.props
    return (
      <div style={{ padding: '10px' }}>
        {!markerData.huntWind && <>
          {!fromEdit && <><div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{
              border: '2px solid #589500',
              borderRadius: 5,
              width: 35,
              height: 35,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 10
            }}>
              <img src={standIconWhite} style={{}}></img>
            </div>
            <h3 style={{
              color: '#ffffff',
              font: 'normal normal normal 30px/45px Oswald'
            }}>Add HuntWind&#8482;</h3>
          </div>
            {this.makeTextInput({ name: 'name', width: '96.2%', access: true, displayVal: markerData.name })}
            <div style={{
              color: 'white',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: 'center',
              alignItems: 'center',
              marginBottom: 10
            }}
            >
              <h3 style={{
                color: '#ffffff',
                font: 'normal normal normal 30px/45px Oswald'
              }}>HuntWind&#8482;</h3>
              <img src={huntImage} style={{
                width: '39px',
                height: '14px',
                marginTop: 10
              }}></img>
            </div>
            <div className='hunt-wind-header-save'>
              Select Ideal Wind Direction(s)
            </div>
            <div className='hunt-wind-prompt-save'>
              Select the wind direction(s) that are most likely to keep your scent from being detected
            </div></>}
        </>}

        <form className='ideal-winds-form' onSubmit={setWinds}>
          {this.makeInputs()}
          <button type='submit'
            onClick={(e) => {
              e.preventDefault()
              if (leftToolbarState.dialog === 'tools') {
                // collapseLeftToolbar()
                this.props.setMarkerData(null)
              }
              else {
                const revert = JSON.parse(markerData.extendedData).huntStandData.preferredWindDirections
                this.props.setWinds(revert)
                toggleEditing()
              }
            }}
            style={{
              width: '50%',
              marginLeft: '-20%',
              backgroundColor: '#4F4F4F',
              opacity: '1'
            }}>Back
          </button>
          <button style={{ width: '50%' }} type='submit' name='doneButton'>Save</button>
        </form>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  leftToolbarState: state.leftToolbarState,
  mapReference: state.mapReference(),
  markerTypes35: state.markerTypes35
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(SetIdealWinds)
